import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import './translations/i18n';
import 'react-datepicker/dist/react-datepicker.css';
import { envSetting } from './constants/envSetting';
import eruda from 'eruda';
import { trimLowerCase } from './helpers/shared';

if ((envSetting.isErudaEnabled === 'true') && (trimLowerCase(import.meta.env.MODE) === 'development')) {
  eruda.init();
  console.log('Eruda initiated successfully');
}

const root = ReactDOM.createRoot(
  document.getElementById('root')
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);